export default __webpack_public_path__ + "static/media/fb.a83dcc94.svg";